
const IdentityDoc = {
    fetch(id) {
        return axios.get(window.getIdentityDocUrl + '/' + id);
    },
    store(data) {
        return axios.post(window.storeIdentityDocUrl, data);
    }
};

export { IdentityDoc };



// WEBPACK FOOTER //
// ./resources/assets/js/services/IdentityDoc.js